// Flow types automatically removed

import { Component } from 'react';
import { graphql, fetchQuery_DEPRECATED as fetchQuery } from 'react-relay/legacy';
import { getBuyerId } from 'dibs-cookie-jar';
import { asyncSendToFriendModal } from '../../shared/asyncSendToFriendModal';
import { trackContactDesignerSubmit } from 'dibs-interiors-photos/exports/trackingHelpers';
export class DesignerDirectoryContactModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            ShareModal: null,
            senderEmail: '',
        };
    }

    componentDidMount() {
        asyncSendToFriendModal().then(ShareModal => {
            this.setState({
                ShareModal,
            });
        });
        const buyerId = getBuyerId(document.cookie) || '';
        fetchQuery(
            this.props.relayEnvironment,
            graphql`
                query DesignerDirectoryContactModalQuery($buyerId: String!, $hasBuyerId: Boolean!) {
                    viewer {
                        user(userId: $buyerId) @include(if: $hasBuyerId) {
                            profile {
                                email
                            }
                        }
                    }
                }
            `,
            {
                buyerId,
                hasBuyerId: !!buyerId,
            }
        ).then(response => {
            this.setState({
                senderEmail: response?.viewer?.user?.profile?.email || '',
            });
        });
    }

    render() {
        const { ShareModal } = this.state;
        const { firmEmail, relayEnvironment } = this.props;

        // Share modal has not been async'd in yet
        if (!ShareModal) {
            return null;
        }

        return (
            <ShareModal
                relay={{
                    environment: relayEnvironment,
                }}
                closeModal={this.props.handleClose}
                modalOpen={this.props.isOpen}
                senderEmail={this.state.senderEmail}
                recipientEmails={[firmEmail]}
                onShareSuccess={() =>
                    trackContactDesignerSubmit({
                        label: 'directory',
                    })
                }
                type="DESIGN_PROFILE"
                key={firmEmail}
            />
        );
    }
}
